module.exports = __webpack_public_path__ + "media/images/countrysquared/be-a0fd8cb8bc8fab171dda887103772635.svg";